import { IWithClassname } from '@/models/common';

export const SvgCloseBlue = ({ className }: IWithClassname) => (
  <svg className={className} width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_900_8849)">
      <rect x="20" y="13" width="48" height="48" rx="24" fill="#3A8EF6" />
      <path d="M38.2023 31.1833L38.1833 31.2023C37.9389 31.4467 37.9389 31.843 38.1833 32.0874L43.0959 37L38.1833 41.9126C37.9389 42.157 37.9389 42.5533 38.1833 42.7977L38.2023 42.8167C38.4467 43.0611 38.843 43.0611 39.0874 42.8167L44 37.9041L48.9126 42.8167C49.157 43.0611 49.5533 43.0611 49.7977 42.8167L49.8167 42.7977C50.0611 42.5533 50.0611 42.157 49.8167 41.9126L44.9041 37L49.8167 32.0874C50.0611 31.843 50.0611 31.4467 49.8167 31.2023L49.7977 31.1833C49.5533 30.9389 49.157 30.9389 48.9126 31.1833L44 36.0959L39.0874 31.1833C38.843 30.9389 38.4467 30.9389 38.2023 31.1833Z" fill="white" />
    </g>
    <defs>
      <filter id="filter0_d_900_8849" x="0.285713" y="0.142856" width="87.4286" height="87.4286" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="6.85714" />
        <feGaussianBlur stdDeviation="9.85714" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.254902 0 0 0 0 0.517647 0 0 0 0 0.968627 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_900_8849" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_900_8849" result="shape" />
      </filter>
    </defs>
  </svg>
);